import { ToggleButton, Typography } from "@mui/material";
import { DowlonadButton } from "Components/DownloadButton";
import { SwitchButton } from "Components/SwitchButton";
import { TablizoCustom } from "Components/LabIZO/Tablizo";
import { DATA_LINK } from "connectors/datalink";
import { DOMAIN } from "config/config";
export const TABLE_SCHEMA: TablizoCustom = (tbLang) => [
  {
    label: "Enabled",
    name: "enabled",
    width: 100,
    reqFunc: "enabled",
    Cell(row, field, addOns, fetchData) {
      return <SwitchButton defaultValue={field} URL={DOMAIN + DATA_LINK.DMEdit} row={row} fetchData={fetchData} disabled={row?.status != "ready"} />;
    },
  },
  // {
  //   label: "Document ID",
  //   name: "_id",
  // },
  {
    label: "Document Name",
    name: "alias",
  },
  // {
  //   label: "Context",
  //   name: "contexts.context",
  //   Cell(row, field, addOns) {
  //     return <>{field}</>;
  //   },
  // },

  {
    label: "Reference Link",
    name: "reference.link",
    Cell(row, field, addOns) {
      //return hyperlink
      return (
        <a href={field} target="_blank">
          {field}
        </a>
      );
    },
  },
  {
    label: "Created At",
    name: "CREATED_AT",
  },
  {
    label: "Last Modified Time",
    name: "LASTMODIFIED",
  },
  {
    label: "Text File",
    name: "text_file.location",
    Cell(row, field, addOns) {
      return <DowlonadButton url={field} />;
    },
    width: 100,
  },
  {
    label: "Original File",
    name: "original_file.location",
    Cell(row, field, addOns) {
      return <DowlonadButton url={field} />;
    },
    width: 100,
  },

  {
    label: "Status",
    name: "status",
    Cell(row, field, addOns) {
      return <Typography color={field == "ready" ? "success.main" : "info.main"}>{field}</Typography>;
    },
    width: 100,
  },
];
